import { Offers } from '../../../../private/offers/infrastructure';
import React from "react";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { useTheme } from "@edgelogistics/edge-ui/lib/providers/theme";
import { ApprovalsIcon, ClockFilledIcon } from '../../../../shared/infrastructure';
import { DrawerWrapper } from "../../../../private/layout/infrastructure";

const AppNavigation = createDrawerNavigator();

const DrawerScreens: React.FC = () => {
  const {
    theme: { colors },
  } = useTheme();

  const routes = [
    {
      title: 'Approvals Queue',
      icon: ApprovalsIcon,
      path: 'approvals-queue',
      routes: [],
    },
    {
      title: 'Approvals History',
      icon: ClockFilledIcon,
      path: 'approvals-history',
      routes: [],
    },
  ];

  return (
    <AppNavigation.Navigator
      drawerType={"permanent"}
      sceneContainerStyle={{ backgroundColor: 'transparent', overflow: 'scroll', marginTop: 30 }}
      drawerStyle={{
        width: 'auto',
        borderRightWidth: 0,
        backgroundColor: 'transparent',
        paddingBottom: 40,
        height:'80%',
        marginTop: 30
      }}
      screenOptions={{ title: "Carrier Approvals" }}
      drawerContent={(props) => <DrawerWrapper {...props} routes={routes} />}
    >
      <AppNavigation.Screen name="approvals-queue" component={(props) => <Offers tab="queue" {...props} />} />
      <AppNavigation.Screen name="approvals-history" component={(props) => <Offers tab="history" {...props} />} />
    </AppNavigation.Navigator>
  );
};

export default DrawerScreens;
